import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GetLeaderboardOutputDto } from '../../../models/leaderboard/dto/leaderboard.dto';

export const GET_LEADERBOARD_QUERY_KEY = (organizationId: string, sport: string) => [
    organizationId,
    'leaderboard',
    sport,
];

export const useGetLeaderboard = (organizationId: string, sport: string) => {
    const client = useApiClient();

    return useQuery({
        enabled: Boolean(organizationId) && Boolean(sport),
        queryKey: GET_LEADERBOARD_QUERY_KEY(organizationId, sport),
        queryFn: () =>
            client.fetchApi<GetLeaderboardOutputDto, {}>({
                endpoint: `dashboard-leaderboard/${organizationId}?sport=${encodeURIComponent(sport)}&limit=200`,
                method: 'GET',
            }),
        staleTime: 60_000,
    });
};
